module.exports = __webpack_public_path__ + "img/cfoot-bg.bf9fdbdf.png";